// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 179) return "styles/main.31d6cfe0d16ae931b73c.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};